import React from 'react';

import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import ButtonToolbar from 'react-bootstrap/ButtonToolbar';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';

import psv from './PSV';
import AlgorithmBox from './AlgorithmBox';
import Variable from './Variable';
import Knowledge, { readConstants, readVariables } from './Knowledge';
import Party from './Party';
import EventBox from './EventBox';
import Message from './Message';
import Finalise from './Finalise';
import ModalDialog from './ModalDialog';
import Assignment from './Assignment';
import Tool from './Tool';
import ToolsetBox from './ToolsetBox';
import KnowledgeElement from './KnowledgeElement';
import TypeSet, { stringSet } from './TypeSet';
import Function from './Function';
import PreBox from './PreBox';
import PostBox from './PostBox';


class Protocol extends React.Component {
  constructor(props) {
    super(props);
    this.finRef = React.createRef();
    
    this.state = {
        messages : props.messages ? props.messages : []
      , messageRefs : props.messageRefs ? props.messageRefs : []
      , parties : props.parties ? props.parties : []
      , finalise : props.finalise ? props.finalise : <Finalise />
      , showAddMessage : false
      , addMessageValidated : false
      , addButton : undefined
      , knowledges : props.knowledges ? props.knowledges : []
      , knowledgeRefs : props.knowledgeRefs ? props.knowledgeRefs : []
    };
    
    // Add button
    this.state.addButton = this.getAddButton();
//     this.state.knowledges.push([]);
//     this.state.knowledges.push([]);
//     this.state.knowledges["Alice"] = this.state.knowledges[0];
//     this.state.knowledges["Bob"]   = this.state.knowledges[1];
    this.state.knowledgeRefs.push(React.createRef());
    this.state.knowledgeRefs.push(React.createRef());
    this.state.knowledgeRefs["Alice"] = this.state.knowledgeRefs[0];
    this.state.knowledgeRefs["Bob"]   = this.state.knowledgeRefs[1];

    /* Sets */
//     let knowledgeAlice = <Knowledge owner="Alice" elements={this.state.knowledges["Alice"]} mumbleView={true}  readonly={false} ref={this.state.knowledgeRefs["Alice"]}/>;
//     let knowledgeBob = <Knowledge owner="Bob" elements={this.state.knowledges["Bob"]}     mumbleView={true} readonly={false} ref={this.state.knowledgeRefs["Bob"]}/>;
//     let alice = <Party name="Alice" knowledge={knowledgeAlice} />;
//     let bob = <Party name="Bob" knowledge={knowledgeBob} />;
    /*
    let knowledgeAliceFinal = <Knowledge elements={this.state.knowledges["Alice"]} stage={-1} readonly={false} />;
    let knowledgeBobFinal = <Knowledge elements={this.state.knowledges["Bob"]}     stage={-1} readonly={false} />;*/
//     let abAlice = <AlgorithmBox statements={[]} />;
//     let abBob = <AlgorithmBox statements={[]} />;
//     let finals = [
//           [alice, abAlice, knowledgeAliceFinal]
//         , [bob, abBob, knowledgeBobFinal]
//       ];
//     finals["Alice"] = finals[0];
//     finals["Bob"]   = finals[1];
//     
//     let finalise = <Finalise
//       finals={finals}
//       ref={this.finRef}
//       messages={this.state.messages}
//       />;
//     this.state.parties.push(alice);
//     this.state.parties.push(bob);
//     this.state.finalise = finalise;
    
    /*BEGIN Initial Knowledge and parties */
    let natSet = <TypeSet name="N" tex='\mathbb{N}' />;
    let prime = <Variable name="p" scope="" deterministic="variable-deterministic" typeset={natSet} tex="p"/>;

    let primeField = <TypeSet name="Zp" tex='\mathbb{Z}_p' />;
    let kep = <KnowledgeElement content={prime} stage="0" />;
    let groupGenerator = <Function
      name="g"
      arity={0}
      notation="plain"
      symbol="g"
      typesets={[primeField]}
      arguments={[]}
      tex=""
    />;
    let keg = <KnowledgeElement content={groupGenerator} stage="0" />;
    
    let knowledgeBob = <Knowledge elements={[kep, keg]} mumbleView={true} readonly={false} ref={this.state.knowledgeRefs["Bob"]}/>;
    let knowledgeAlice = <Knowledge elements={[kep, keg]} mumbleView={true}  readonly={false} ref={this.state.knowledgeRefs["Alice"]}/>;
    
    let alice = <Party name="Alice" knowledge={knowledgeAlice} />;
    let bob = <Party name="Bob" knowledge={knowledgeBob} />;

    this.state.parties.push(alice);
    this.state.parties.push(bob);
    /*END Initial Knowledge and parties */
    
    /*BEGIN First message */
    let x = <Variable name="x" scope="" deterministic="variable-probabilistic" typeset={natSet} tex="x"/>;
    let sampleX = <Assignment lvalue={x} rvalue={natSet} deterministic={false}/>;
    let kex = <KnowledgeElement content={x} stage="0" />;
    
    let X = <Variable name="X" scope="" deterministic="variable-deterministic" typeset={primeField} tex="X"/>;
    let gAtX = <Function
      name="exp"
      arity={2}
      notation="infix"
      symbol="exp"
      typesets={[primeField, natSet, primeField]}
      arguments={[groupGenerator, x]}
      tex="^"
    />;
    let xGetsGAtX = <Assignment lvalue={X} rvalue={gAtX} deterministic={true}/>;
    let keX = <KnowledgeElement content={X} stage="0" />;
    
    
    let pre1 = <PreBox statements={[sampleX, xGetsGAtX]} stage="1"/>;

    let event1 = <EventBox variables={[X]} direction="send" stage="1"/>;
    let post1 = <PostBox statements={[]} stage="1" />;
    
    let knowledgeBobMsg1 = <Knowledge elements={[kep, keg, keX]} mumbleView={false} readonly={true}/>;
    let knowledgeAliceMsg1 = <Knowledge elements={[kep, keg, kex, keX]} mumbleView={false} readonly={true}/>;
//     this.state.knowledges.push(knowledgeBobMsg1);
//     this.state.knowledges.push(knowledgeAliceMsg1);
//     let aliceM1 = <Party name="Alice" knowledge={knowledgeAliceMsg1}/>;
//    
    let message1 = 
    <Message 
             fromParty={"alice"}
             toParty={"bob"}
             knowledgeLeft={knowledgeAliceMsg1}
             knowledgeRight={knowledgeBobMsg1}
             direction={"send"} 
             stage={0}
             pre={pre1} 
             event={event1}
             post ={<PostBox/>}
    />;
    this.state.messages.push(message1);
    
    /*END First message */
    
    /*BEGIN Second message */
    let y = <Variable name="y" scope="" deterministic="variable-probabilistic" typeset={natSet} tex="y" />;
    let sampleY = <Assignment lvalue={y} rvalue={natSet} deterministic={false} />;
    let key = <KnowledgeElement content={y} stage="2" />;
        
    let Y = <Variable name="Y" scope="" deterministic="variable-deterministic" typeset={primeField} tex="Y"/>;
    let gAtY = <Function
      name="exp"
      arity={2}
      notation="infix"
      symbol="exp"
      typeset={[primeField, natSet, primeField]}
      arguments={[groupGenerator, y]}
      tex="^"
    />;
    let yGetsGAtY = <Assignment lvalue={Y} rvalue={gAtY} />;
    let keY = <KnowledgeElement content={Y} stage="2" />;
    
    let pre2 = <PreBox statements={[sampleY, yGetsGAtY]} />;
    let event2 = <EventBox variables={[Y]} direction="receive" />;
;

    let knowledgeBobMsg2 = <Knowledge elements={[kep, keg, keX, key, keY]} mumbleView={false} readonly={false}/>;
    let knowledgeAliceMsg2 = <Knowledge elements={[kep, keg, kex, keX, keY]} mumbleView={false} readonly={false}/>;
    
    let message2 = 
        <Message 
        fromParty={alice} 
        toParty={bob} pre={pre2} 
        event={event2} 
        post ={<PostBox/>} 
        knowledgeLeft={knowledgeBobMsg2} 
        knowledgeRight={knowledgeAliceMsg2} 
        direction="receive"/>;
    this.state.messages.push(message2);
    
    
    /*END Second message */
     /*BEGIN Finalise */
    let kA = <Variable name="kA" scope="" deterministic="variable-probabilistic" typeset={primeField} typeset={primeField} tex="k_A" />;
    let yAtX = <Function
      name="exp"
      arity={2}
      notation="infix"
      symbol="exp"
      typeset={[primeField, natSet, primeField]}
      arguments={[Y, x]}
      tex="^"
    />;
    let kGetsYAtX = <Assignment lvalue={kA} rvalue={yAtX} />;
    let abAlice = <AlgorithmBox statements={[kGetsYAtX]} />;
    let keKA = <KnowledgeElement content={kA} stage="-1" />;
    let knowledgeAliceFinal = <Knowledge elements={[kep, keg, kex, keX, keY, keKA]} />;
    
    let kB = <Variable name="kB" scope="" deterministic="variable-probabilistic" typeset={primeField} typeset={primeField} tex="k_B" />;
    let xAtY = <Function
      name="exp"
      arity={2}
      notation="infix"
      symbol="exp"
      typeset={[primeField, natSet, primeField]}
      arguments={[X, y]}
      tex="^"
    />;
    let kGetsXAtY = <Assignment lvalue={kB} rvalue={xAtY} />;
    let abBob = <AlgorithmBox statements={[kGetsXAtY]} />;
    let keKB = <KnowledgeElement content={kB} stage="-1" />;
    let knowledgeBobFinal = <Knowledge elements={[kep, keg, keX, key, keY, keKB]} />;
    
    let finalise = <Finalise ref={this.finRef}
        finals={[
            [alice, abAlice, knowledgeAliceFinal]
            , [bob, abBob, knowledgeBobFinal]
        ]} />;

    this.state.finalise = finalise;
    /*END Finalise */
  }
  getAddButton = () => {
     return("");
        }
  
  showModalDialog = () => {
    var state = this.state;
    state.showAddMessage = true;
    this.setState(state);
  }
  
  hideModalDialog = () => {
    var state = this.state;
    state.showAddMessage = false;
    this.setState(this.state);
  }
  
  declareStatements = (statements, entity) => {
    if (statements) {
      //console.log(statements[0].props.lvalue.props.typeset.props.name);
      return (
        statements.map((ke) =>
          <declaration
            variable={ke.props.lvalue.props.name}
            entity={entity}
            set={ke.props.lvalue.props.typeset.props.name}
            hint={ke.props.lvalue.props.hint}
          >
          </declaration>
        )
      );
    } else {
      return <></>;
    }
  }
  
  addMessage = () => {    
    var state = this.state;
    var messageRef = React.createRef();
    
    let   knowledgeBobMsg = <Knowledge elements={this.state.knowledges["Bob"]}   stage={this.state.messages.length + 1} readonly={false} />;
    let knowledgeAliceMsg = <Knowledge elements={this.state.knowledges["Alice"]} stage={this.state.messages.length + 1} readonly={false} />;
    let fromIdx = document.getElementById('addMessage.fromParty').value;
    let toIdx = document.getElementById('addMessage.toParty').value;
    let direction = (fromIdx - toIdx > 0) ? "receive" : "send";
    
    state.messageRefs.push(messageRef);
    state.messages.push(
      <Message
        fromParty={this.state.parties[fromIdx]}
        toParty={this.state.parties[toIdx]}
        knowledgeLeft={knowledgeAliceMsg}
        knowledgeRight={knowledgeBobMsg}
        direction={direction}
        stage={state.messages.length + 1}
        ref={messageRef}
      />);
    state.showAddMessage = true;
    state.addButton = this.getAddButton();
    
    this.hideModalDialog(); // this also updates the state
  }
  
  toPSV =() => {
      return(
    <>
	  <sets>
        <set id="N" tex="\mathbb{N}" description="Natural numbers"></set>
        <set id="Zp" tex="\mathbb{Z}_p" description="Integers modulo p"></set>
    </sets>
  
    <customfunctions>
        <function id="exp" arity="2" notation="corner-ne" hint="group-exponentiation">
            <argset set="Zp"></argset>
            <argset set="N"></argset>
            <argset set="Zp"></argset>
        </function>
        <function id="g" hint="group-exponentiation">
            <argset set="Zp"></argset>
        </function>
        <function id="p">
            <argset set="N"></argset>
        </function>
        <function id="eq" arity="2" tex="=" notation="infix" hint="equality">
            <argset set="Zp"></argset>
            <argset set="Zp"></argset>
        </function>
    </customfunctions>
  
    <declarations>
        <declaration variable="x"  entity="A" set="N"></declaration>
        <declaration variable="y"  entity="B" set="N"></declaration>
        <declaration variable="kA" entity="A" set="Zp" tex="k_A" label="k"></declaration>
        <declaration variable="kB" entity="B" set="Zp" tex="k_B" label="k"></declaration>
        <declaration variable="gx" entity="A" set="Zp" tex="X"></declaration>
        <declaration variable="gy" entity="B" set="Zp" tex="Y"></declaration>
    </declarations>
  
    <protocol name="Diffie-Hellman key exchange">
        <description>Exchange a long term secret key</description>
    
        <entity id="A" name="A" desc="Alice">
        </entity>
        <entity id="B" name="B" desc="Bob">
        </entity>
    
        <message id="m-1" from="A" to="B">
            <knowledge entity="A">
                <variable id="g" type="constant"></variable>
            </knowledge>
            <knowledge entity="B">
                <variable id="g" type="constant"></variable>
            </knowledge>
            <pre>
                <assignment variable="x" type="probabilistic"></assignment>
                <assignment variable="gx">
                    <application function="exp">
                        <argument id="g" type="constant"></argument>
                        <argument id="x" type="nonce"></argument>
                    </application>
                </assignment>
            </pre>
            <event type="send">
                <variable id="gx"></variable>
            </event>
            <channel security="insecure"></channel>
            <event type="receive">
                <variable id="gx"></variable>
            </event>
            <post></post>
            <comment>send public key to other party</comment>
        </message>
    
        <message id="m-2" from="B" to="A">
            <knowledge entity="A">
                <variable id="g" type="constant"></variable>
                <variable id="x" type="nonce"></variable>
                <variable id="gx"></variable>
            </knowledge>
            <knowledge entity="B">
                <variable id="g" type="constant"></variable>
                <variable id="gx"></variable>
            </knowledge>
            <pre>
                <assignment variable="y" type="probabilistic"></assignment>
                <assignment variable="gy">
                    <application function="exp">
                        <argument id="g" type="constant"></argument>
                        <argument id="y" type="nonce"></argument>
                    </application>
                </assignment>
            </pre>
            <event type="send">
                <variable id="gy"></variable>
            </event>
            <channel security="insecure"></channel>
            <event type="receive">
                <variable id="gy"></variable>
            </event>
            <post></post>
            <comment>send public key to other party</comment>
        </message>
    
        <finalise entity="A" lastmessage="m-2">
            <assignment variable="kA">
                <application function="exp">
                    <argument id="gy"></argument>
                    <argument id="x" type="nonce"></argument>
                </application>
            </assignment>
        </finalise>
    
        <finalise entity="B" lastmessage="m-2">
            <assignment variable="kB">
                <application function="exp">
                    <argument id="gx"></argument>
                    <argument id="y" type="nonce"></argument>
                </application>
            </assignment>
        </finalise>
    
        <properties>
            <securityparameter id="n">512</securityparameter>
            <correctness>
                <application function="eq">
                    <argument id="kA"></argument>
                    <argument id="kB"></argument>
                </application>
            </correctness>
            <authentication integrity="A" towards="B"></authentication>
            <authentication integrity="B" towards="A"></authentication>
            <confidentiality>
                <secret variable="k">
                    <allowed entity="A"></allowed>
                    <allowed entity="B"></allowed>
                </secret>
            </confidentiality>
        </properties>
    </protocol>
    </>
    );
      
}
  toPSV_old = () => {
    var fromParty = this.state.parties[0];
    var toParty = this.state.parties[1];
    var finalise = "";
    
    if (this.finRef && this.finRef.current) {
      finalise = this.finRef.current.toPSV();
    }
    
    
    // TODO: move to Party
    const entities = this.state.parties.map((p) =>
      <entity
        id={p.props.name}
        name={p.props.name}
        desc={p.props.name}
      >
        {this.state.knowledgeRefs[p.props.name].current.decoratedRef.current.toPSV()}
      </entity>
    );
    
    // TODO: Filter out builtin and functions/0
      // WARNING: duplicates of common initial knowledge and wrong format!
//         {this.state.parties.map((p) => {
//           return (
//             <>
//               {readConstants(this.state.knowledgeRefs[p.props.name].current.decoratedRef.current.state.boxes, 0)}
//               {readVariables(this.state.knowledgeRefs[p.props.name].current.decoratedRef.current.state.boxes, 0)}
//             </>
//           );
//         })}
    const declarations = 
      <>
        {this.state.messageRefs.map((m) =>
          this.declareStatements(m.current.preRef.current.state.statements, m.current.state.left.props.name)
        )}
        {this.finRef.current.state.finals.map((pak) =>
          this.declareStatements(pak[1].props.statements, pak[0].props.name)
        )}
        {this.state.messageRefs.map((m) =>
          this.declareStatements(m.current.preRef.current.state.statements, m.current.state.left.props.name)
        )}
      </>;
    
        
    
//     this.state.parties.map((p) => 
//       this.state.knowledgeRefs[p.props.name].current.decoratedRef.current.state.boxes
//         .filter((ke) => ke.props.content.type === <Variable />.type)
//         .map((ke) => 
//           <declaration
//             variable={ke.props.content.props.name}
//             entity={p.props.name}
//           >
//           </declaration>
//         )
//       );
    return (
      <>
        <declarations>
          {declarations}
        </declarations>
        <protocol>
          {entities}
          {this.state.messageRefs.map((r) => r.current.toPSV())}
          {finalise}
          <properties>
          </properties>
        </protocol>
      </>
    );
  }
  
  render() {
    var form = getAddMessageForm(this.state.parties);
    var button = (this.state.messages.length > 0)
      ? <Container>
          <Row>
            <Col>
              <ButtonToolbar>
                {this.state.addButton}
              </ButtonToolbar>
            </Col>
          </Row>
        </Container>
      : <Container>
          <Row>
            <Col>
              <ButtonToolbar>
                {this.state.addButton}
              </ButtonToolbar>
            </Col>
            <Col></Col>
            <Col></Col>
          </Row>
        </Container>
    
    return (
      <Container className="protocol">
        <Container className="parties">
          <Row className="parties">
            {this.state.parties.map((b, i) =>
              <Col key={i}>{b}</Col>
            )}
          </Row>
        </Container>
        <Container className="messages">
          {this.state.messages.map((b, i) =>
            <Row key={i} className="message">
              <Col>{b}</Col>
            </Row>
          )}
          {button}
        </Container>
        {this.state.finalise}
        <ModalDialog
          title="Add new message"
          show={this.state.showAddMessage}
          onClose={this.hideModalDialog}
          onApply={this.addMessage}
          form={form} />
      </Container>
    );
  }
}

export function getAddMessageForm(parties) {
  var form = 
    <Form>
      <Form.Group as={Row} controlId="addMessage.fromParty">
        <Form.Label column sm="3">From party: </Form.Label>
        <Col sm="6">
          <Form.Control as="select">
            {parties.map((b,i) =>
              <option key={i} value={i}>{b.props.name}</option>
            )}
          </Form.Control>
        </Col>
      </Form.Group>
      <Form.Group as={Row} controlId="addMessage.toParty">
        <Form.Label column sm="3">To party: </Form.Label>
        <Col sm="6">
          <Form.Control as="select">
            {parties.map((b,i) =>
              <option key={i} value={i}>{b.props.name}</option>
            )}
          </Form.Control>
        </Col>
        <Form.Control.Feedback type="valid">You did it!</Form.Control.Feedback>
      </Form.Group>
    </Form>;
  
  return form;
}

export default psv(Protocol);
